__turbopack_context__.v({
  "formActionsWrapper": "DiECua_formActionsWrapper",
  "orientationLeft": "DiECua_orientationLeft",
  "orientationRight": "DiECua_orientationRight",
});
